import { APISportsManagement } from '@/components/admin/APISportsManagement';

const APISportsManagementPage = () => {
  return <APISportsManagement />;
};

export default APISportsManagementPage;
